export default __webpack_public_path__ + "images/icons/instagram-d35a09868b7a4dd47bbde5e91d613029.svg";